import InvestorLayout from "./InvestorLayout"

export default InvestorLayout
